import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import PrintExportDropdown from '@/layouts/components/common/PrintExportDropdown.vue'

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component('PrintExportDropdown', PrintExportDropdown)
